<template>
    <div class="motorbike-details-page">
        <!-- banner -->
        <div class="banner">
            <img :src="bannerUrl" class="img" />
        </div>
        <!-- 导航 -->
        <div class="nav-wrap">
            <div>
                <a v-for="(item,idx) in baseTabs.list" :key="idx" @click="scorllHref(item)">{{item.label}}</a>
            </div>
        </div>
        <!-- 规格 -->
        <div id="models-show" class="specification-wrap">
            <!-- 标题组件 -->
            <base-son-title enTitle="PRODUCT FEATURES" title="产品" title1="特色" class="animate__animated animate__zoomIn animate__slow"></base-son-title>
            <!-- 规格选择 -->
            <div class="specification-detail">
                <div class="specification-opt animate__animated animate__fadeInLeftBig animate__slow"  ref="specification_left">
                    <p class="txt-1">{{carModel}}</p>
                    <div>
                        <p class="txt-2" v-for="(item,idx) in versions" :key="idx">{{item.name}} - ￥{{item.price}}</p>
                    </div>
                    <p class="txt-3">{{des}}</p>
                    <em class="split-line"></em>
                    <p class="txt-4" v-if="versions.length == 0">￥{{price}}</p>
                    <!-- 颜色选择 -->
                    <div class="color-group">
                        <div v-for="(item, idx) in colorGroupConf.list" :key="idx" 
                            :class="['color', colorGroupConf.active === item.id ? 'actww' : '']"
                            @click="onOptCurrentColor(item)"
                        >
                            <div class="icon-wrap">
                                <img v-if="item.imgAct && !item.color" :src="colorGroupConf.active === item.id ? item.spec_color_img[1] : item.spec_color_img[0]" class="icon" />
                                <div v-if="item.color" class="icon1" :style="'background-color:' + item.color" :class="colorGroupConf.active === item.id?'iconactqq':''"></div>
                            </div>
                            <!-- <span class="txt">{{ item.name }}</span> -->
                        </div>
                    </div>
                    <!-- 用户手册下载 -->
                    <div class="btn-group">
                        <button class="btn">
                            <img src="~@/assets/img/motorbike-details/icon-yhsc.png" class="icon" />
                            <span class="txt" @click="userManualDownload">用户手册下载</span>
                        </button>
                    </div>
                </div>
                <!-- 车辆展示 -->
                <div class="swiper-wrap animate__animated animate__fadeInRightBig animate__slow">
                    <div class="swiper-btn prev" @click="swiperClzsPrev"></div>
                    <swiper :options="swiperClzs.options" ref="swiperClzs">
                        <swiper-slide v-for="(item, idx) in swiperClzs.list" :key="idx">
                            <img class="s-img" :src="item" />
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-btn next" @click="swiperClzsNext"></div>
                </div>
            </div>
        </div>
        <!-- tvc -->
        <div class="tvc-wrap">
            <!-- 产品TVC -->
            <div id="product-tvc" class="chunk-1" ref="productTvc">
                <!-- 标题组件 -->
                <base-son-title enTitle="PRODUCT TVC" title="产品" title1="TVC" :class="productTvcShow == true ? 'animate__animated animate__zoomIn animate__slow' :''"></base-son-title>
                <video v-if="tvcVideoUrl" controls controlslist="nodownload" :src="tvcVideoUrl" :class="productTvcShow == true ? 'video animate__animated animate__zoomIn':''"></video>
                <el-empty v-else description="暂无数据" style="height:400px;"></el-empty>
            </div>
            <!-- 车型亮点 -->
            <div id="car-window" class="chunk-2" ref="carWindow">
                <!-- 标题组件 -->
                <base-son-title enTitle="HIGHLIGHT" title="车型" title1="亮点" :class="carWindowShow == true ? 'animate__animated animate__zoomIn animate__slow' : ''"></base-son-title>
                <div class="cont">
                    <div class="swiper-btn prev" @click="swiperClldPrev"></div>
                    <swiper :options="swiperClld.options" ref="swiperClld">
                        <!-- slides -->
                        <swiper-slide v-for="(item, idx) in swiperClld.list" :key="idx">
                            <div class="card-group">
                                <div class="card" :class="carWindowShow == false ? '' : item.count == 0 ? 'animate__animated animate__fadeInLeftBig animate__slow' : item.count == 1 ? 'animate__animated animate__zoomInUp animate__slow' : item.count == 2 ? 'animate__animated animate__fadeInRightBig animate__slow' : '' ">
                                    <img :src="item.preview" class="img" />
                                    <div class="btm">
                                        <p class="txt-1">{{ item.title }}</p>
                                        <p class="txt-2">{{ item.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <!-- Optional controls -->
                        <div id="swiper-clld-pagination" class="swiper-pagination swiper-clld-pagination" slot="pagination"></div>
                    </swiper>
                    <div class="swiper-btn next" @click="swiperClldNext"></div>
                </div>
            </div>
            <!-- 参数配置 -->
            <div id="parameter-configuration" class="chunk-3" ref="parameterConfiguration">
                <base-son-title enTitle="CONFIGURE" title="参数" title1="配置" :class="parameterConfigurationShow == true ? 'animate__animated animate__zoomIn animate__slow' : ''"></base-son-title>
                <div class="cont">
                    <div v-for="(item, idx) in configure" :key="parseInt(idx)">
                        <div class="unit">
                            <p class="txt-1">{{ item.title }}</p>
                            <p class="txt-2">
                                <animate-number v-if="parameterConfigurationShow&&item.num" :formatter="formatter" from="0" :to="item.num" duration="1000"></animate-number>
                                <span class="txt-2" v-if="item.num1">/</span>
                                <animate-number v-if="parameterConfigurationShow&&item.num1" from="0" :to="item.num1" duration="1000"></animate-number>
                            </p>
                            <p class="txt-3">{{ item.unit }}</p>
                            <p class="txt-4">{{ item.txt1 }}</p>
                            <p class="txt-5">{{ item.txt2 }}</p>
                        </div>
                        <em v-if="idx != (configure.length - 1)" class="split-line"></em>
                    </div>
                </div>
                <button class="btn">
                    <span class="txt" @click="showArguments">查看完整参数</span>
                </button>
            </div>
            <el-dialog :visible.sync="dialogTableVisible">
                <div class="car-arguments">
                    <div class="title"> 
                        <p>整车参数</p>
                    </div>
                    <div class="parts-name"> 
                        <div v-for="(item,idx) in configureDetails1" :key="idx">{{item.name}}</div>
                    </div>
                    <div class="parts-val"> 
                        <div v-for="(item,idx) in configureDetails1" :key="idx">{{item.value}}</div>
                    </div>
                    <div class="parts-name"> 
                        <div v-for="(item,idx) in configureDetails2" :key="idx">{{item.name}}</div>
                    </div>
                    <div class="parts-val"> 
                        <div v-for="(item,idx) in configureDetails2" :key="idx">{{item.value}}</div>
                    </div>
                </div>
                <div class="car-arguments">
                    <div class="title"> 
                        <p>发动机参数</p>
                    </div>
                    <div class="parts-name"> 
                        <div v-for="(item,idx) in configureDetails3" :key="idx">{{item.name}}</div>
                    </div>
                    <div class="parts-val"> 
                        <div v-for="(item,idx) in configureDetails3" :key="idx">{{item.value}}</div>
                    </div>
                    <div class="parts-name"> 
                        <div v-for="(item,idx) in configureDetails4" :key="idx">{{item.name}}</div>
                    </div>
                    <div class="parts-val"> 
                        <div v-for="(item,idx) in configureDetails4" :key="idx">{{item.value}}</div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { productDetailsApi } from "../../../request/api.js";
import BaseSonTitle from "@/components/BaseSonTitle.vue";
import bus from "@/utils/bus";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "toMotorbikeDetails",
    components: {
        BaseSonTitle,
        swiper,
        swiperSlide,
    },
    data() {
        return {
            bannerUrl:'',
            color:'#000',
            des:'', //车辆描述
            price:'', //价格
            versions:'', //版本号
            carModel:'', //车型
            tvcVideoUrl:'', //video地址
            downloadUrl:'', //用户手册下载地址
            dialogTableVisible:false,
            num:0,
            productTvcShow:false, //产品TVC显隐
            carWindowShow:false, //车型亮点显隐
            parameterConfigurationShow:false, //参数配置显隐
            currentScroll: null,
            baseTabs: {
                list: [
                    { label: "产品TVC", name: "2"},
                    { label: "车型亮点", name: "3"},
                    { label: "配置参数", name: "4"},
                    { label: "预约试驾", name: "1"},
                ],
            },
            /* 车辆展示 */
            swiperClzs: {
                options: {
                    loop: false,
                },
                list: [],
            },
            /* 车辆亮点 */
            swiperClld: {
                options: {
                    slidesPerView:3,
                    pagination: { el: '#swiper-clld-pagination', clickable: true }
                },
                list: [],
            },
            /* 参数配置 */
            configure: [
                {
                    title: "扭矩（N·m）",
                    num: "",
                    num1: "",
                    unit: "N·m",
                    txt1: "",
                    txt2: "油箱容积（L)",
                },
                {
                    title: "功率（kW）",
                    num: "",
                    num1: "",
                    unit: "kW",
                    txt1: "",
                    txt2: "长×宽×高（mm)",
                },
                {
                    title: "质量（kg）",
                    num: "",
                    unit: "kg",
                    txt1: "",
                    txt2: "离地间隙（mm)",
                },
                {
                    title: "坐高（mm)",
                    num: "",
                    unit: "mm",
                    txt1: "",
                    txt2: "轴距（mm)",
                },
            ],
            /* 参数详情 */
            configureDetails1:[],
            configureDetails2:[],
            configureDetails3:[],
            configureDetails4:[],
            /* 颜色组配置 */
            colorGroupConf: {
                active: 1,
                list: [],
            },
        };
    },
    created(){
        this.productDetailsApi()
    },
    computed: {
        swiperClzsEl() {
            return this.$refs.swiperClzs.swiper;
        },
        swiperClldEl() {
            return this.$refs.swiperClld.swiper;
        },
        
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll)
        
    },
    methods: {
        productDetailsApi(){
            const params = {
                m:'Mobile',
                c:'MajorProduct',
                a:'get_product_info',
                id:this.$route.query.id,
                store_id:21,
                lang:1,
                types:''
            }
            productDetailsApi(params).then(({data})=>{
                console.log(data.datas.info.pro_name);
                this.bannerUrl = data.datas.info.slide_img
                // 车辆描述
                this.des = data.datas.info.collocate
                // 车型
                this.carModel = data.datas.info.pro_name
                //版本号
                this.versions = data.datas.info.versions
                // 价格
                this.price = data.datas.info.price
                // 用户手册下载地址
                this.downloadUrl = data.datas.info.file_url
                // 颜色参数
                data.datas.info.list.forEach((item,idx) => {
                    item.id = idx+1
                    this.colorGroupConf.list.push(item)
                    this.swiperClzs.list.push(item.image[0])
                });
                // tvc视频
                this.tvcVideoUrl = data.datas.info.tvc_url
                // 亮点
                this.swiperClld.list = data.datas.info.content
                // 参数配置
                data.datas.info.field.other_list.forEach((item,idx) => {
                    console.log(item);
                    if (
                        item.name == '长×宽×高（mm)'||
                        item.name == '质量（kg）'||
                        item.name == '轴距（mm)'||
                        item.name == '最高车速（Km/h）'
                    )
                    { this.configureDetails1.push(item) }

                    if (
                        item.name == '离地间隙（mm)'||
                        item.name == '油箱容积（L)'||
                        item.name == '制动方式'||
                        item.name == '坐高（mm)'
                    ){ this.configureDetails2.push(item) }

                    if (
                        item.name == '缸径×行程（mm)'||
                        item.name == '发动机型式'||
                        item.name == '功率（kW）'||
                        item.name == '变速器型式'
                    ){ this.configureDetails3.push(item) }
                    if(this.carModel == 'SR4Max' && item.name == '防抱死系统'){
                        this.configureDetails3.push(item)
                    }
                    if(this.carModel == 'SR150GT' && item.name == '防抱死系统'){
                        this.configureDetails3.push(item)
                    }
                    if (
                        item.name == '扭矩（N·m）'||
                        item.name == '排放标准'||
                        item.name == '压缩比'||
                        item.name == '排量（ml)'
                    ){ this.configureDetails4.push(item) }
                    // 扭矩
                    if (item.name == this.configure[0].title) {
                        let value = item.value.split('/')
                        this.configure[0].num = value[0]
                        this.configure[0].num1 = value[1]
                    }
                    // 油箱容积
                    if (item.name == this.configure[0].txt2) {
                        this.configure[0].txt1 = item.value
                    }
                    // 功率
                    if (item.name == this.configure[1].title) {
                        let value = item.value.split('/')
                        this.configure[1].num = value[0]
                        this.configure[1].num1 = value[1]
                    }
                    // 长宽高
                    if (item.name == this.configure[1].txt2) {
                        this.configure[1].txt1 = item.value
                    }
                    // 质量
                    if (item.name == this.configure[2].title) {
                        let value = item.value
                        this.configure[2].num = value
                    }
                    // 离地间隙
                    if (item.name == this.configure[2].txt2) {
                        this.configure[2].txt1 = item.value
                    }
                    // 坐高
                    if (item.name == this.configure[3].title) {
                        let value = item.value
                        this.configure[3].num = value
                    }
                    // 轴距
                    if (item.name == this.configure[3].txt2) {
                        this.configure[3].txt1 = item.value
                    }
                });
            })
        },
        // 点击导航跳转对应位置
        scorllHref(val){
            switch (val.name) {
                case '2':
                    this.$refs.productTvc.scrollIntoView({behavior: 'smooth'})
                    break;
                case '3':
                    this.$refs.carWindow.scrollIntoView({behavior: 'smooth'})
                    break;
                case '4':
                    this.$refs.parameterConfiguration.scrollIntoView({behavior: 'smooth'})
                    break;
                case '1':
                    bus.$emit('actNum',6)
                    this.$router.push({
                        path: "/test-drives"
                    });
                    break;
                default:
                    break;
            }
        },
        // 用户手册下载
        userManualDownload(){
            if (this.downloadUrl == '') {
                this.$message.warning('暂无下载内容')
            }else{
                window.open(this.downloadUrl)
            }
        },
        // 参数配置 animate-number插件 自定义数据类型
        formatter(num){
            if (String(num).indexOf(".") > -1) {
                return num.toFixed(1)
            }else{
                return parseInt(num)
            }
        },
        /**
         * @Description: tab 被选中时触发
         * @return {*}
         */
        baseTabsClick(item) {
          window.location.href = '/motorbike-details' + item.toId
        },
        /**
         * @Description: 车辆展示,上一张
         * @return {*}
         */
        swiperClzsPrev() {
            this.swiperClzsEl.slidePrev();
            this.colorGroupConf.active = this.swiperClzsEl.activeIndex+1
        },
        /**
         * @Description: 车辆展示,下一张
         * @return {*}
         */
        swiperClzsNext() {
            this.swiperClzsEl.slideNext();
            // Tip: 这里"this.swiperClzsEl.activeIndex" 为当前sweiper显示内容下标，"this.colorGroupConf.active" 从1开始，所以需要+1
            this.colorGroupConf.active = this.swiperClzsEl.activeIndex+1 
        },
        /**
         * @Description: 车辆亮点,上一张
         * @return {*}
         */
        swiperClldPrev() {
            this.swiperClldEl.slidePrev();
        },
        /**
         * @Description: 车辆亮点,下一张
         * @return {*}
         */
        swiperClldNext() {
            this.swiperClldEl.slideNext();
        },
        /**
         * @Description: 选中当前颜色
         * @param {*} color
         * @return {*}
         */
        onOptCurrentColor(color) {
            this.colorGroupConf.active = color.id;
            // Tip: 这里"slideto()"是根据swiper内容下标定位，"color.id" 从1开始，所以-1
            this.$refs.swiperClzs.swiper.slideTo(color.id-1)
        },
        /**
         * @Description: 滑动监听
         * @param {*} 
         * @return {*}
         */
        handleScroll(){
            this.currentScroll = window.pageYOffset //表示当前滚动的位置
            // 产品TVC
            if (this.currentScroll >= this.$refs.productTvc.offsetTop - 900) {
                this.productTvcShow = true
            }
            // 车型亮点
            if(this.currentScroll >= this.$refs.carWindow.offsetTop - 900){
                this.carWindowShow = true
            }
            // 参数配置
            if(this.currentScroll >= this.$refs.parameterConfiguration.offsetTop - 900){
                this.parameterConfigurationShow = true
            }
        },
        showArguments(){
            this.dialogTableVisible = true
        }
    },
    destroyed(){
        window.removeEventListener('scroll',this.handleScroll);
    }
};
</script>
<style lang="scss">
@import "./motorbike-details.scss";
</style>



// WEBPACK FOOTER //
// src/views/motorbike-details/motorbike-details.vue